import React, { Component, useState, useEffect,  } from 'react';
import HeaderPage from '../../Components/HeaderPages';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Spinner  } from "react-awesome-spinners";
import Aviso from '../../Components/Aviso';
import CaixaInforme from '../../Components/CaixaInforme';
import Butao from '../../Components/Butao_list';
import Pagination from '../../Components/Pagination';
import TACriarTreino from './TACriarTreino';
import TAEditarTreino from './TAEditarTreino';
import TATreinoAluno from './TATreinoAluno';
import Api from '../../Api';
import FinderSelect from 'react-finderselect';
import Select from 'react-select';



export default ({DadCont, InfIdUse, InfIdConta, IdConta, IdUse, CidEst, Dados, setDados, Loading,  setLoading,  Alert, setAlert, AlertTipo,
   setAlertTipo, Avisando, setAvisando}) => {
      const [Offset, setOffset] = useState(0);
      const [Limit, setLimit] = useState(10);
      const [Quant, setQuant] = useState(0);
      const [Pag1, setPag1] = useState(false);
      const [Pag2, setPag2] = useState(false);
      const [Pag3, setPag3] = useState(false);
      const [Pag4, setPag4] = useState(false);
      const [Titulo, setTitulo] = useState("Treinos");
      const [UsuariosContServ, setUsuariosContServ] = useState([]);
      const [Lista, setLista] = useState(["list"]);
      const [Carreg, setCarreg] = useState(false);
      const [Cont, setCont] = useState(0);
      const [Id, setId] = useState("");
      const [Nome, setNome] = useState("");
      const [AddList, setAddList] = useState(null);
      const [ListEsp, setListEsp] = useState({});
      const [ListCliente, setListCliente] = useState([]);
      const [Cliente, setCliente] = useState("");
      const [ListNomeTrei, setListNomeTrei] = useState([]);
      const [NomeTrei, setNomeTrei] = useState("");
      const [NomeRepr, setNomeRepr] = useState("");
      const [IdContRes, setIdContRes] = useState(IdConta);
      const [selectedOption, setSelectedOption] = useState(null);
      const [Progress, setProgress] = useState(10);
      const [ListContas, setListContas] = useState([]);
      const [ListContasTel, setListContasTel] = useState([]);
      const [ContasNome, setContasNome] = useState([]);
      const [ContasTel, setContasTel] = useState([]);
      
     
      useEffect(() => {
       ListApp();     
      }, [IdContRes])

      useEffect(() => {
         if(AddList !== null){
          AdicionandoLista()
           LimpandoPesq()
         }
       }, [AddList])
     

      useEffect(() => {
      
        Listando(); 
        
       }, [UsuariosContServ])

       useEffect(() => {
        Listando();
       }, [Offset])
     
        useEffect(() => {
            if(Cliente !== ""  ){
                PesCliente();
            }
           }, [Cliente])
        useEffect(() => {
            if(NomeTrei !== ""  ){
                PesNomeTrei();
            }
           }, [NomeTrei])
       
        useEffect(() => {
            listandoContas();     
            }, [])

          const listandoContas = async ()=>{
                    await Api.TAListClientesSelect(Dados, setListContas, setListContasTel);
                  }
 

            
            
             
             const PesCliente = ()=>{
              
             
              let listra1 = [];
              let listra2 = [];
              for(let i in UsuariosContServ ) {
                  if( UsuariosContServ[i].NomeUser.toLowerCase().includes(Cliente.toLowerCase() ) ) {
                    listra1.push(UsuariosContServ[i]);  
                   
                  const novoItem3 = {
                  value: UsuariosContServ[i].Id,
                   label: UsuariosContServ[i].Nome,  
                  };

                  const existe3 = listra2.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                  if (!existe3) {
                    listra2.push(novoItem3);
                  }
                  
                  }
                  
                }
                 setListNomeTrei(listra2)
                 setCarreg(false)
                 setLista(["list"]);
                 setQuant(listra1.length);
                setUsuariosContServ(listra1);
                
              
             
             
               
            } 
     
          const PesNomeTrei = ()=>{
              
             
              let listra1 = [];
             
              
              for(let i in UsuariosContServ ) {
                  if( UsuariosContServ[i].Nome.toLowerCase().includes(NomeTrei.toLowerCase() ) ) {
                   listra1.push(UsuariosContServ[i]); 
                   setCliente(UsuariosContServ[i].NomeUser)
                  }
                 
                }
                
                setCarreg(false)
                 setLista(["list"]);
                 setQuant(listra1.length);
                setUsuariosContServ(listra1);
                
              
             
             
               
            } 
           
     
          const ListApp = async ()=>{
            if (navigator.onLine) {
             setCarreg(true);
             setLista(["list"]);
              setProgress(10)
             await Api.TAListTreinos(Dados, IdContRes, setQuant, setUsuariosContServ, setListCliente, setListNomeTrei, setProgress, setCarreg);
             
            } else {
              setAlert("Sem Internet");
              setAlertTipo("danger");
            }

               
          }
        const AdicionandoLista = async ()=>{
          if(Lista[0] === "list"){
            setLista([
              {
                list:AddList
              }]);

          } else {
          setLista([
              {
                list:AddList
              },
              ...Lista,
            ]);
          }
          
        
          }

          const Listando = async ()=>{
                
                  const cal1 = Quant/Limit;
                  const cal2 = Math.trunc(cal1);
                  const cal3 = cal2*10;
                  const cal4 = Quant - cal3;
                  if(Offset === cal3) {
                      
                          const inicio = Offset;
                          const fim = Quant;
                          var Listinha =[];
                          for (var i = inicio; i < fim; i++) {
                            Listinha.push({
                              list:UsuariosContServ[i],
                            });
                            setLista(Listinha);
                          
                    

                          }

                  } else {

                          const inicio = Offset;
                          const fim = (Offset + Limit) 
                          var Listinha =[];
                          for (var i = inicio; i < fim; i++) {
                            Listinha.push({
                              list:UsuariosContServ[i],
                            });
                            setLista(Listinha);
                           
                   

                        }
                  

                    } 

                    var num= Cont + 1;
                    setCont(num);
                    if(Cont === 1){
                      setCarreg(false); 
                    }          
                         
          }

          function confirma() {
            setAlert(" ");
            setAlertTipo(" ");
            setPag2(false);
            setPag1(false);
           
          }
          function cancelar() {
            setAlert(" ");
            setAlertTipo(" ");
            setPag2(false);
            setPag1(false);
          }

          const Fechar = ()=>{
            setPag2(false);
            setPag1(false);
            setPag3(false);
            setPag4(false);
          }


               
               


                

         

               const Pagina1 = ()=>{
                 setPag1(true);
               }

                const Pagina3 = async (id , Lista)=>{
                setPag1(true);
                setPag2(true);
                setPag3(true);
                setId(id);
                setListEsp(Lista);
              }

              const Pagina4 = async (id)=>{
                setId(id);
                setPag1(true);
                setPag2(true);
                setPag3(true);
                setPag4(true);
              }

               const Pagina2 = async (id , Lista)=>{
                await setId(id);
                await setPag1(true);
                await setPag2(true);
                await setListEsp(Lista);

              }

                const MsgDesativar = (id, nome)=>{
                  setId(id);
                  setNome(nome);
                  setAlert("Ok");
                  setAlertTipo("Desativar");
                  
                }

                const Desativar = async (Id, nome)=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                 const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, Ativo:false } : item
              );
                setUsuariosContServ(novaLista);
                await Api.TADesativandoTreino(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }

                const MsgAtivar = (id, nome)=>{
                  setId(id);
                  setNome(nome);
                  setAlert("Ok");
                  setAlertTipo("ativar");
                  
                }

                 const Ativar = async (Id, nome)=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                 const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, Ativo:true } : item
              );
                setUsuariosContServ(novaLista);
                await Api.TAAtivandoTreino(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }
                 const LimpandoPesq = ()=>{
                    ListApp() 
                    setCliente("")
                    setNomeRepr("")
                    setNomeTrei("")
                    setCarreg(true)
                    setLista(["list"])

                  }
                const printValue3 = (target) => {
                    setCliente(target.label)

                }
                const printValue4 = (target) => {
                  console.log(target)
                    setNomeTrei(target.label)
                   
              
                }
               
          const printValue5 = (target) => {
                setIdContRes(target.value)
                setContasNome(target.label)
                setContasTel(target.Tel)
                }
           const printValue6 = (target) => {    
           setIdContRes(target.value)
           setContasNome(target.Nome)
           setContasTel(target.label)
           }
      
  return (
        
          <div>
             {Alert !== " " && AlertTipo === "success" &&
                  <SweetAlert  success title={Alert} onConfirm={confirma} onCancel={cancelar} />
                }

            {Alert !== " " && AlertTipo === "danger" &&
                  <SweetAlert  danger title={Alert} confirmBtnBsStyle="danger" onConfirm={confirma} onCancel={cancelar} />
                }


            { Alert !== " " && AlertTipo === "Desativar" &&
              <SweetAlert
              warning
              showCancel
              confirmBtnText="Sim"
              cancelBtnText="Não"
              confirmBtnBsStyle="danger"
              onConfirm={()=>Desativar()}
              onCancel={cancelar}
              focusCancelBtn
            >
              Tem certeza que deseja Desativar a condicional {Nome}!
            </SweetAlert>
            }
            { Alert !== " " && AlertTipo === "ativar" &&
              <SweetAlert
              warning
              showCancel
              confirmBtnText="Sim"
              cancelBtnText="Não"
              confirmBtnBsStyle="danger"
              onConfirm={()=>Ativar()}
              onCancel={cancelar}
              focusCancelBtn
            >
              Tem certeza que deseja ativar a condicional {Nome}!
            </SweetAlert>
            }
            { Pag1 === false ?
            <div className="content-wrapper">
               
              <HeaderPage
              Avisando={Avisando} 
              Titulo={Titulo}
              />            
              <section className="content">
                <div className="container-fluid">
                  
                <div className="row">
                  <section className="col-12">
                  {Loading === true ?
                        <Spinner 
                        size={64}
                        color={"#5d0bf7"}
                        sizeUnit={'px'} 
                        />
                        :
                        <>
                         <div className="row">
                                <CaixaInforme 
                                cor={"small-box bg-success"}
                                valor={Quant}
                                porcentagen={false}
                                nome={"Quant. Treinos na Lista"}
                                icon={"fas fa-edit"}
                                link={false}
                                />
                                              {/* <CaixaInforme 
                                              cor={"small-box bg-success"}
                                              valor={"53"}
                                              porcentagen={true}
                                              nome={"Rendimentos"}
                                              icon={"ion ion-stats-bars"}
                                              link={false}
                                              />
                                              <CaixaInforme 
                                              cor={"small-box bg-warning"}
                                              valor={"44"}
                                              porcentagen={false}
                                              nome={"Contas Subordinadas"}
                                              icon={"ion ion-person-add" }
                                              link={false}
                                              />
                                              <CaixaInforme 
                                              cor={"small-box bg-danger"}
                                              valor={"65"}
                                              porcentagen={false}
                                              nome={"Visitas"}
                                              icon={"ion ion-pie-graph"}
                                              link={false}
                                              />                            */}
                                           </div>
                                            {ListCliente.length !== 0 &&
                      <>
                      {InfIdConta && Object.keys(InfIdConta).length > 0 &&
                        <>
                        {InfIdConta.MensagemSistem.Ativo &&
                      <div class="alert alert-warning alert-dismissible">
                              <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                              <h5><i class="icon fas fa-exclamation-triangle"></i> Alert!</h5>
                              {InfIdConta.MensagemSistem.Msg}
                            </div>
                        }
                        </>   
                        }
                        {InfIdConta && Object.keys(InfIdConta).length > 0 &&
                        <>
                        {InfIdConta.TempLimitAtiv < new Date().getTime() &&
                      <div class="alert alert-danger alert-dismissible">
                              <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                              <h5><i class="icon fas fa-exclamation-triangle"></i> Alert!</h5>
                             A mensalidade da sua conta vence em {new Date(InfIdConta.TempLimitAtiv).toLocaleDateString('pt-BR')}. Entre em contato com a empresa e realize o pagamento. Caso o pagamento não seja efetuado em até 5 dias após o vencimento, os aplicativos dos seus alunos serão bloqueados. 
                            </div>
                        }
                        </>   
                        }
                     <div className="card card-default">
                    <div className="card-header">
                        <h3 className="card-title">Filtros para pesquisa</h3>
                    </div>
                    {/* /.card-header */}
                    <div className="card-body">
                    <div className="row" >
                       
                    <div className="col-sm-4">
                        <div className="form-group">
                          {ListCliente.length !== 0 &&
                      <>
                        <strong>Nome do Criador do Treino</strong><br />
                        <div className="input_cadatro">
                        {Cliente ?
                        <>
                          <string style={{}}>{Cliente}</string><br />
                        </>
                        :  
                        <Select
                        defaultValue={Cliente}
                        onChange={(target) => printValue3(target)}
                        options={ListCliente}
                        placeholder={"Escolha o Criador"}
                      />
                        }
                      </div> 
                </>
                    }
                            
                          
                        </div>
                        </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          {ListNomeTrei.length !== 0 &&
                      <>
                        <strong>Nome do Treino</strong><br />
                        <div className="input_cadatro">
                        {NomeTrei ?
                        <>
                          <string style={{}}>{NomeTrei}</string><br />
                        </>
                        :  
                     
                      <Select
                        defaultValue={NomeTrei}
                        onChange={(target) => printValue4(target)}
                        options={ListNomeTrei}
                        placeholder={"Escolha o Treino"}
                      />
                        }
                      </div> 
                </>
                    }
                            
                          
                        </div>
                        </div>
                        

                        <div className="col-sm-4">
                            <div className="form-group" style={{marginTop:22}}>
                              
                            <Butao 
                            style={"btn btn-sm btn-secondary"}
                            titulo={"Limpar Pesquisa"}
                            onClick={()=>LimpandoPesq()}
                            />
                            </div>
                            </div> 


                    </div>
                    </div>
                    </div>
                    </>
                     }
                    <div className="card card-danger">
                       {Dados &&
                      <>
                      {Dados.Treinos.Btn.botão_Criar &&
                      <>
                       <div style={{margin:"10px", width:"250px"}}>
                        <Butao 
                        style={"btn btn-sm btn-info"}
                        titulo={"Criar Treino"}
                        onClick={()=>Pagina1()}
                        />

                        </div>
                                </>
                                }
                                </>
                                }
                     
                        
                        {DadCont === "Emp" &&
                                  <>
                              
                                {ListContas.length !== 0 &&
                                <>
                            
                            <div  style={{width:250, marginBottom:10, marginLeft:5}}>
                              <Select
                                defaultValue={ContasNome}
                              onChange={(target) => printValue5(target)}
                              options={ListContas}
                              placeholder={"Escolha  o Nome "}
                            />    
                            
                          </div> 
                            <div  style={{width:250, marginBottom:10, marginLeft:5}}>
                              <Select
                                defaultValue={ContasTel}
                              onChange={(target) => printValue6(target)}
                              options={ListContasTel}
                              placeholder={"Escolha  o Telefone"}
                            />    
                            
                          </div> 
                          <string style={{marginBottom:10, marginLeft:5}}>Cliente: {ContasNome} - Tel: {ContasTel}</string>
                            
                          </>
                              }
                                </>
              
                                      }
                      
                      <div className="card-header">
                      
                        <h3 className="card-title" style={{ marginBottom: "10px"}}>Lista de Treinos</h3> 

                      </div>
                        <div class="card-body table-responsive p-0">
                          <table class="table table-hover text-nowrap">
                            <thead>
                              <tr>
                                <th>Ações</th>
                                <th>Nome do Treino</th> 
                                <th>Nome do Criador</th>
                                
                                
                              </tr>
                            </thead>
                            
                            { Lista[0].list ?
                            <tbody >
                            {Lista.map((item, key)=>(
                            
                            
                                    <tr key={item.list.Id} style={{backgroundColor: item.list.Ativo=== false ?"#F4B0B9":"#FFF"}} >
                                     <td>
                                    
                                    {item.list.Ativo===true ?
                                    <>
                               
                                    <Butao 
                                    style={"btn btn-xs btn-success"}
                                    titulo={"Vizializar"}
                                    onClick={()=>Pagina2(item.list.Id, item.list)}
                                    />
                                        {Dados &&
                                          <>
                                        {Dados.Treinos.Btn.botão_Desativar &&
                                        <>
                                        <Butao 
                                        style={"btn btn-xs btn-secondary"}
                                        titulo={"Desativar"}
                                        onClick={()=>Desativar(item.list.Id, item.list.Nome)}
                                        />
                                              </>
                                              }
                                              </>
                                              }
                                  
                                      
                                      </>
                                      :
                                      <>
                                  
                                      <Butao 
                                      style={"btn btn-xs btn-success"}
                                      titulo={"Vizualizar"}
                                      onClick={()=>Pagina2(item.list.Id, item.list)}
                                      /> 
                                    {Dados &&
                                      <>
                                    {Dados.Treinos.Btn.botão_Ativar &&
                                    <>
                                    <Butao 
                                    style={"btn btn-xs btn-warning"}
                                    titulo={"Ativar"}
                                    onClick={()=>Ativar(item.list.Id, item.list.Nome)}
                                    /> 
                                          </>
                                          }
                                          </>
                                          }
                                    
                                     
                                    
                                      </>
                                    }                                     
                                                           
                                    </td>
                                    
                                    <td>{item.list.Nome}</td>
                                   
                                    <td>

                                     {item.list.NomeUser}                            
                                                               
                                    </td>
                                   
                                   
                                  </tr>
                                 
                             ))}
                                </tbody> 
                                :
                                      <>
                                      { Carreg === true ?
                                         <>
                                        <div className="progress" style={{ height: "25px" }}>
                                          <div
                                            className="progress-bar bg-primary progress-bar-striped"
                                            role="progressbar"
                                            style={{ width: `${Progress}%` }}
                                            aria-valuenow={Progress}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                          >
                                            {Progress.toFixed(2)}% Completo
                                          </div>
                                        </div>
                                         <p style={{ margin:"20px"}}>Espere, Estamos Preparando a lista.</p>
                                         </>
                                        :                                      
                                      <p style={{color:"red", margin:"20px"}}>Não existe Treino Cadastrado</p>
                                      }
                                      </>
                            }
                            
                            
                          </table>
                            <Pagination
                            limit={Limit} 
                            total={Quant} 
                            offset={Offset}
                            setOffset={setOffset}
                            />
                         </div>
                        </div>
                       
                        </>
                        }
                    </section>       
               </div>
            </div>
          </section>
        </div>
        :
        <>
        {Pag2 === false ?
          <TACriarTreino
          setAddList={setAddList}
          setUsuariosContServ={setUsuariosContServ}
          UsuariosContServ={UsuariosContServ}
          setAlert={setAlert}
          setAlertTipo={setAlertTipo}
          Avisando={Avisando}
          Fechar={Fechar}
          Dados={Dados}
          Id={Id}
          Nome={Nome}
          IdConta={IdConta}
          IdUse={IdUse} 
          InfIdConta={InfIdConta}
          InfIdUse={InfIdUse} 
            />
          :
          <>
          {Pag3 === false ?
             <TAEditarTreino 
            setUsuariosContServ={setUsuariosContServ}
            UsuariosContServ={UsuariosContServ}
            setAlert={setAlert}
            setAlertTipo={setAlertTipo}
            Avisando={Avisando}
            Fechar={Fechar}
            Dados={Dados}
            Id={Id}
            ListEsp={ListEsp}
            IdConta={IdConta}
            IdUse={IdUse} 
            InfIdConta={InfIdConta}
            InfIdUse={InfIdUse} 
            />
          :
          <>
           {Pag4 === false ?
           <>
            <TATreinoAluno 
            setUsuariosContServ={setUsuariosContServ}
            UsuariosContServ={UsuariosContServ}
            setAlert={setAlert}
            setAlertTipo={setAlertTipo}
            Avisando={Avisando}
            Fechar={Fechar}
            Dados={Dados}
            Id={Id}
            ListEsp={ListEsp}
            IdConta={IdConta}
            IdUse={IdUse} 
            InfIdConta={InfIdConta}
            InfIdUse={InfIdUse} 
            />

           </>
          :
          <>

          </>
           }
          </>
          }
          </>
         
        }
        
        </>
   
         }
      </div>

        );
    }

